import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CourseVolumeItem } from '.';
export const CourseVolumes = ({ volumes, classObject, onClickVolume }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(CourseVolumeItem, { latestVolume: volumes[0], classObject: styles.volume, isNotGenerated: true }),
        volumes.map((volume, i) => (React.createElement(CourseVolumeItem, { key: i, volume: volume, onClickVolume: onClickVolume, classObject: styles.volumeClickable })))));
};
const styles = StyleSheet.create({
    container: {},
    volume: {
        marginTop: 16,
    },
    volumeClickable: {
        marginTop: 16,
        cursor: 'pointer',
    },
});
